import { useSelector } from 'react-redux';

export const getFeatureFlags = (state) => {
  const { features, hasRequestSucceeded: hasLoaded } = state.featureToggle;

  return {
    features,
    loading: !hasLoaded,
    refreshAvailabilityCalendarFlagIsEnabled: true,
    refreshSearchRevampFlagIsEnabled: true,
    infiniteLoadingFixFlagIsEnabled: true,
    sunsetMessageDisplayFlagIsEnabled: hasLoaded
      ? features.get('dining-sunset-message-display')
      : true,
    readOnlyModeFlagIsEnabled: hasLoaded
      ? !!features.get('dining-read-only-mode')
      : true,
  };
};

export const useFeatureFlags = () => {
  return useSelector(getFeatureFlags);
};
